import React, { Component } from 'react';
import { connect } from 'react-redux';
import TopMenuItem from './TopMenuItem.jsx';
import { Link } from 'react-router-dom';
import qs from 'qs';
import axios from 'axios';
import fetchMe from '../../actions/fetchMe';
import { NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react'

class TopMenu extends Component {
  constructor(props) {
    super(props);
    this.state={
      show_my:false,
    }
  }
  renderMenu() {
    if(this.props.menu.top && this.props.menu.top.length) {
      return this.props.menu.top.map((item)=>{
        return (
          <TopMenuItem key={item.name} {...item} />
        )
      });
    }
    return null;
  }
  getAuthUrl() {
    let parsed=qs.parse(this.props.router.location.search,{ ignoreQueryPrefix:true });
    parsed.popup=`/user/auth`;
    const string=qs.stringify(parsed);
    return `${this.props.router.location.pathname}?${string}`;
  }
  getRegistrerUrl() {
    let parsed=qs.parse(this.props.router.location.search,{ ignoreQueryPrefix:true });
    parsed.popup=`/user/register`;
    const string=qs.stringify(parsed);
    return `${this.props.router.location.pathname}?${string}`;

  }
  logOut() {
    this.props.meStore.logOut();
  }
  renderAuthedMenu() {
    return (
      <div className="fr">
        <span className="dib pointer clear tdni w1 menuHeight" onClick={()=>{ this.logOut() }}>
          <span className="up12 h100 splice hpadd20"><span className="cell s-auto s-middle">
            Log Out
          </span></span>
        </span>
      </div>
    )
  }
  renderGuestMenu(){
    return (
      <div className="fr">
        <div className="fr">
          <Link className="dib clear tdni w1 menuHeight" to={this.getAuthUrl()}>
            <span className="up12 h100 splice hpadd20"><span className="cell s-auto s-middle">
              Auth
            </span></span>
          </Link>
        </div>
        <div className="fr">
          <Link className="dib clear tdni w1 menuHeight" to={this.getRegistrerUrl()}>
            <span className="up12 h100 splice hpadd20"><span className="cell s-auto s-middle">
            Register
            </span></span>
          </Link>
        </div>
      </div>
    )
  }
  clickOnMy() {
    this.setState({ show_my:!this.state.show_my });
  }
  renderMyItems() {
    const myMenu=[
      {name:'Shelf',route:`/shelf/${this.props.me.nick}`},
      {name:'Figures',route:`/shelf/${this.props.me.nick}/figures`},
      {name:'Anime',route:`/shelf/${this.props.me.nick}/anime`},
      {name:'Photos',route:`/shelf/${this.props.me.nick}/photos`},
      {name:'Spying',route:`/shelf/${this.props.me.nick}/spying`},
    ];

    return myMenu.map((item)=>{
      return (
        <NavLink key={item.route} className="w1 clear tdni db hpadd20 vpadd10 " activeClassName="bg-b1" exact to={item.route}>{item.name}</NavLink>
      )
    })
  }
  renderMy() {
    return (
      <div className="menuHeight pr" onClick={()=>{ this.clickOnMy(); }}>
        <div className="up12 splice h100">
          <div className="cell s-middle s-12">
            <span className="font1  pointer fs20 dib">
              My <i className="mdi mdi-chevron-down"></i>
            </span>
          </div>
        </div>
        <div className="pa bg-b2 clear tdni w1" style={{zIndex:9,top:'100%', display:this.state.show_my?'block':'none', left:0}}>
          {this.renderMyItems()}
        </div>
      </div>
    );
  }
  render() {
    return (
      <div>hello</div>
    );
    return (
      <div>
        <div className="menuHeight m-dn"></div>
        <div className="menuHeight bg-b2 w2 only-s-pf w100 pa-tl" style={{zIndex:10}}>
          <div className="max padding">
            <div className="up12 menuHeight margin h100 m-dn">
              <div className="cell s-middle s-shrink only-s-pleft10">
                {this.props.me?this.renderMy():'MyAnimeShelf'}
              </div>
              <div className="cell s-middle s-auto tar">
                <span className={`dib toggleMenu `} onClick={()=>{ this.props.toggleMobileMenu(); }}>
                  <span className={`menuBars ${this.props.showMobile?'cross':''}`}></span>
                </span>
              </div>
            </div>
          </div>
          <div className="max padding only-s-dn">
            <div className="up12 margin">
              <div className="cell s-middle s-shrink pleft10">
                {this.props.me?this.renderMy():'MyAnimeShelf'}
              </div>
              <div className="cell s-middle s-auto">
                {this.props.me?this.renderAuthedMenu():this.renderGuestMenu()}
                {this.renderMenu()}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    menu:state.menu,
    router:state.router,
    me:state.me
  }
}


// export default inject("router","meStore")(observer(TopMenu));
export default inject("router","meStore")(observer(TopMenu));